<template>
  <div class="operate_center blue">
    <door-box :height="812" width="100%">
      <template v-if="!dialogValue.state">
        <div class="top">
          <maintenanceEquipment></maintenanceEquipment>
        </div>
        <div class="bottom">
          <operateWork></operateWork>
        </div>
      </template>
      <template v-if="dialogValue.state && (dialogValue.params.type=='生产治理同步率' || dialogValue.params.type=='高频高幅' || dialogValue.params.type=='设备在线率')">
        <deviceOnline></deviceOnline>
      </template>
      <template v-if="dialogValue.state && (dialogValue.params.type=='保养校准' || dialogValue.params.type=='问题处理' || dialogValue.params.type=='日常巡检' || dialogValue.params.type=='维护事件' || dialogValue.params.type=='诊断详情')">
        <deviceStatistic></deviceStatistic>
      </template>
    </door-box>
  </div>
</template>

<script>
import doorBox from '../components/doorBox';
import deviceOnline from '../components/dialog/deviceOnline.vue';
import deviceStatistic from '../components/dialog/deviceStatistic.vue';
import operateWork from './component/operateWork';
import maintenanceEquipment from './component/maintenanceEquipment';
import { mapState, mapGetters } from "vuex";
export default {
  name: 'index',
  components: {doorBox,operateWork,maintenanceEquipment,deviceOnline, deviceStatistic},
  computed: {
    // ...mapGetters({ dialogValue: "getOperationCenterDialog" }),
    dialogValue() {
      return this.$store.state.operationCenterDialog
    }
  },
  watch: {
    dialogValue: {
      handler(newVal, oldVal) {
        console.log("ceshi", newVal)
      },
      deep: true,
    }
  }
}
</script>

<style lang="scss" scoped>
.operate_center {
  height: 100%;
  margin-left: 20px;
  .isBaoSteel {
    background: #020F3F;
  }
  .box_wrap {
    height: 100%;
  }
  .top {
    height: 49%;
    @include bg-box(100%, 49%, 'centerTop.png');
    margin-bottom: 10px;
  }
  .bottom {
    height: 50%;
    padding-top: 10px;
    padding-left: 10px;
    @include bg-box(100%, 50%, 'centerBottom.png');
  }
}
.blue {
  background: rgba(0, 106, 255, 0.05);
  border: 1px solid rgba(132, 170, 255, 0.5);
}
</style>
